import { render, staticRenderFns } from "./docManage.vue?vue&type=template&id=34bf85f8&scoped=true"
import script from "./docManage.vue?vue&type=script&lang=js"
export * from "./docManage.vue?vue&type=script&lang=js"
import style0 from "./docManage.vue?vue&type=style&index=0&id=34bf85f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf85f8",
  null
  
)

export default component.exports